<div class="card-header d-flex ps-0" id="headingTwo" data-bs-toggle="collapse" href="#collapseTwo">
    <a class="card-link flex-fill">Exceptions</a>
    <i class="fas fa-chevron-up"></i>
</div>
<div id="collapseTwo" class="collapse show">
    <div class="card-body">
        @if (gridConfig) {
        <div [style.height.px]="gridHeight">
            <inavista-grid #shipmentOrderExceptionsGrid class="so-popup-grid"
                [config]="gridConfig"
                [actionIcons]="actionIcons"
                (hyperlinkClick)="showMasterItemCodePopup(exceptionFor($event.row))"
                (rowEditStart)="onRowEditStart($event)"
                (rowCommit)="onRowCommit($event)"
                (rowRevert)="onRowRevert($event)"
                (actionIconClick)="onActionIconClick($event)"
                (toolbarActionClick)="onToolbarActionClick($event)" />
        </div>
        }
    </div>
</div>

<!-- Return: the old clickable checkbox (locked on a saved exception and on Unknown). -->
<ng-template #returnCell let-row>
    <span [title]="exceptionFor(row)?.shoExceptionId || exceptionFor(row)?.reasonDescription === 'Unknown' ? 'Return can be changed on a new exception that is not Unknown.' : ''">
        <ejs-checkbox
            [checked]="exceptionFor(row)?.isReturn"
            [disabled]="exceptionFor(row)?.shoExceptionId || exceptionFor(row)?.reasonDescription === 'Unknown'"
            (change)="onCheckboxClicked($event, exceptionFor(row))"
        ></ejs-checkbox>
    </span>
</ng-template>

<!-- The open row's cells: each column's editor (CellEditorHost, @inavista/components controls). -->
<ng-template #reasonEditor let-row>
    <app-cell-editor [edit]="edits.reasonDescription" field="reasonDescription" [rowData]="editRowFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #itemEditor let-row>
    <app-cell-editor [edit]="edits.itemCode" field="itemCode" [rowData]="editRowFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #descriptionEditor let-row>
    <app-cell-editor [edit]="edits.itemDescription" field="itemDescription" [rowData]="editRowFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #quantityEditor let-row>
    <app-cell-editor [edit]="edits.quantity" field="quantity" [rowData]="editRowFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #typeEditor let-row>
    <app-cell-editor [edit]="edits.type" field="type" [rowData]="editRowFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #returnEditor let-row>
    <app-cell-editor [edit]="edits.isReturn" field="isReturn" [rowData]="editRowFor(row)" [registry]="openEditors" />
</ng-template>

<!-- The open row's hidden columns (Quantity, Type): their editors, out of sight, as the old grid had them. -->
@if (hiddenEditRow) {
    <div class="d-none" aria-hidden="true">
        @for (field of hiddenEditFields; track field) {
            <app-cell-editor [edit]="edits[field]" [field]="field" [rowData]="hiddenEditRow" [registry]="openEditors" />
        }
    </div>
}

<app-items-advanced-search
    *ngIf="showItemAdvancedSearchPopup"
    [technicianId]="$safeNavigationMigration(shipmentOrderData?.technicianId)"
    (onClose)="onItemAdvancedSearchPopupClose($event)"
></app-items-advanced-search>
